export const columnData = {
  Code: { name: 'Código', widthCol: '5%' },
  DateCreated: { name: 'Fecha de creación', widthCol: '15%' },
  ErrorMessage: { name: 'Mensaje de error', widthCol: '40%' },
  CreatedBy: { name: 'Creado por', widthCol: '10%' },
  RequestMethod: { name: 'Método de solicitud', widthCol: '15%' },
  RequestPath: { name: 'Ruta de solicitud', widthCol: '15%' }
}
